import { ISectionItem } from '@posx/core';

// Calculate next table position within a section region (109px per table width)
export const getNextPos = (list: ISectionItem[], regionWidth: number = 820) => {
  if (!list || list.length === 0) return { row: 0, col: 0 };
  const maxRow = Math.max(...list.map((item) => item.row));
  const maxColInMaxRow = Math.max(...list.filter((item) => item.row === maxRow).map((item) => item.col)); // Find max col in max row only
  if ((maxColInMaxRow + 1) * 109 > regionWidth) return { row: maxRow + 1, col: 0 }; // Move to next row if width exceeded
  return { row: maxRow, col: maxColInMaxRow + 1 };
};

// Wrap each saved row by its own last col into `cols` columns, then continue unplaced items right after the last placed one
export const wrapGrid = <T extends { col?: number; row?: number }>(list: T[], cols: number) => {
  const rowCols: number[] = [], offsets: number[] = [];
  list.forEach(m => { if (m.col != null) rowCols[m.row!] = Math.max(rowCols[m.row!] ?? 0, m.col + 1); });
  for (let r = 0, y = 0; r < rowCols.length; r++) { offsets[r] = y; y += Math.max(1, Math.ceil((rowCols[r] ?? 0) / cols)); }
  // linear slot index on this screen, -1 for unplaced
  const slots = list.map(m => m.col != null ? (offsets[m.row!] + Math.floor(m.col / cols)) * cols + m.col % cols : -1);
  let next = Math.max(-1, ...slots);
  return list.map((m, k) => { const s = slots[k] >= 0 ? slots[k] : ++next; return { ...m, col: s % cols, row: Math.floor(s / cols) }; });
};

export function preciseRound(num: number, decimalPlaces = 2): number {
  const factor = Math.pow(10, decimalPlaces);
  // toFixed(6) strips binary float tails (103.49999999999999 -> 103.5) so half values round up, same as @posx/core
  return Math.round(+(num * factor).toFixed(6)) / factor;
}
